import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';

import Typography from '../../../components/common/Typography';

import previousAdd1 from '../../../asset/img/previous_add_1.svg';
import previousAdd2 from '../../../asset/img/previous_add_2.svg';

const dotAnimation = keyframes`
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: ''; }
`;

const LoadingText = styled.span`
  &::after {
    content: '';
    animation: ${dotAnimation} 1.5s infinite;
  }
`;

const LoadingStep = ({ typeLabel, htmJType }) => {
  const { t } = useTranslation('previousEmployment');

  const uploadImg = htmJType === '1' ? previousAdd1 : previousAdd2;

  return (
    <div className="displayFlexColumn" style={{ gap: '24px' }}>
      <Typography variant="subtitleBold" style={{ whiteSpace: 'pre-line' }}>
        {t('uploadSection.title', { type: typeLabel })}
      </Typography>
      <div
        className="displayFlex"
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          background: 'var(--GrayScale-100)',
          borderRadius: '16px',
        }}>
        <img src={uploadImg} alt="upload" style={{ height: '90px' }} />
      </div>
      <Typography
        variant="body2Medium"
        style={{ color: 'var(--GrayScale-600)', textAlign: 'center' }}>
        {/* 올바른 문서가 맞는지 분석 중입니다 */}
        <LoadingText>{t('loadingSection.analyzing')}</LoadingText>
      </Typography>
    </div>
  );
};

export default LoadingStep;
